import React, { Component } from "react";

import ReactCardFlip from "react-card-flip";
import "../styles/components/Deputet.css";
import { Icon } from "antd";
const checkImage = path =>
  new Promise(resolve => {
    const img = new Image();
    img.onload = () => resolve({ path, status: "ok" });
    img.onerror = () =>
      resolve({
        path:
          "https://previews.123rf.com/images/apoev/apoev1806/apoev180600066/103284665-default-placeholder-businessman-half-length-portrait-photo-avatar-man-gray-color.jpg",
        status: "error"
      });

    img.src = path;
  });
class Deputet extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isFlipped: false
    };
    this.handleClick = this.handleClick.bind(this);
  }
  componentWillMount = async () => {
    let path = await checkImage(this.props.foto);
    console.log(path);
    this.setState({ path: path.path });
  };
  componentWillReceiveProps = async next => {
    let path = await checkImage(next.foto);
    console.log(path);
    this.setState({ path: path.path });
  };
  handleClick(e) {
    e.preventDefault();
    this.setState(prevState => ({ isFlipped: !prevState.isFlipped }));
  }

  render() {
    console.log(this.props);
    return (
      <div className="cardParent">
        <ReactCardFlip isFlipped={this.state.isFlipped}>
          <div className="deputetFront" key="front">
            <img
              src={
                this.state.path ||
                "https://previews.123rf.com/images/apoev/apoev1806/apoev180600066/103284665-default-placeholder-businessman-half-length-portrait-photo-avatar-man-gray-color.jpg"
              }
              className="deputFoto"
              alt=""
            />
            <h3 className="deputEmer">
              {this.props.emri}&nbsp;{this.props.mbiemri}
            </h3>
            <h6 className="mailLogo">
              <a
                className="mailLogo"
                href={`mailto:${this.props.email}`}
                target="_top"
              >
                Kontakto:&nbsp;
                <Icon type="mail" />
              </a>{" "}
            </h6>
            <button className="deputButton" onClick={this.handleClick}>
              Me Shume
            </button>
          </div>

          <div className="deputetBack" key="back">
            <div className="colTogether">
              <div className="leftCol">
                <h6>Emer:</h6>
                <h6>Atesia:</h6>
                <h6>Mbiemri:</h6>
                <h6>Datelindja:</h6>
                <h6>Vendlindja:</h6>
                <h6>Jeteshkrimi:</h6>
              </div>
              <div className="rightCol">
                <h6>{this.props.emri}</h6>
                <h6>{this.props.atesia ? " " + this.props.atesia : "-"}</h6>
                <h6>{this.props.mbiemri ? " " + this.props.mbiemri : "-"}</h6>
                <h6>
                  {this.props.datelindja ? " " + this.props.datelindja : "-"}
                </h6>
                <h6>
                  {this.props.vendlindja ? " " + this.props.vendlindja : "-"}
                </h6>
                <h6>
                  <a
                    href={this.props.cv ? this.props.cv : "-"}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {" "}
                    Kliko Ketu
                  </a>
                </h6>
              </div>
            </div>
            <button className="deputButton" onClick={this.handleClick}>
              Shko Mbrapa
            </button>
          </div>
        </ReactCardFlip>
      </div>
    );
  }
}
export default Deputet;
